export function toMillions(value: number) {
  return value > 1000000 ? parseFloat((value / 1_000_000).toFixed(2)) : parseFloat((value / 1_000_000).toFixed(5));
}
